import React from "react";
import { Link } from "react-router-dom";
import { Card, CardActionArea, CardMedia, CardContent, Typography } from "@material-ui/core";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ConstructionIcon from "@mui/icons-material/Construction";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import projectCardDefaultImg from "../../../../assets/images/bdt_projectCardDefault.jpg";
import { BDTRoutes } from "../../../helpers/applicationConstants";
import { ProjectDto, ProjectStatusEnum } from "../../../api/APIClient";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "25vw",
        maxWidth: "350px",
        minWidth: "250px",
        minHeight: "172.5px",
        height: "280px",
        marginRight: "5vw",
        marginBottom: "5vw",
    },
    media: {
        height: "50%",
        paddingTop: "56.25%",
    },
    mediaGray: {
        height: "50%",
        paddingTop: "56.25%",
        filter: "grayscale(1)",
    },
    noHover: {
        cursor: "not-allowed",
    },
    hover: {
        cursor: "pointer",
    },
    icon: {
        top: "35%",
        left: "50%",
        position: "absolute",
        transform: "translate(-50%, -50%)",
        color: "#000000",
        width: "120px !important",
        height: "120px !important",
        opacity: "0.8",
    },
}));

interface ProjectCardProps {
    project: ProjectDto;
}

const ProjectCard = ({ project }: ProjectCardProps): JSX.Element => {
    const classes = useStyles();
    const { t } = useTranslation("administration");

    const isReady = project.status === ProjectStatusEnum.Ready;
    const isCreating = project.status === ProjectStatusEnum.Creating;

    const message = () => {
        if (isReady) {
            return "";
        }
        if (isCreating) {
            return `${t("projects.projectCreating")}`;
        }
        return `${t("projects.projectUpdating")}`;
    };

    return (
        <Card className={classes.root} variant="outlined">
            <CardActionArea className={isCreating ? classes.noHover : classes.hover}>
                {isCreating ? (
                    <>
                        <CardMedia
                            className={classes.mediaGray}
                            image={
                                project.projectImageStr
                                    ? project.projectImageStr
                                    : projectCardDefaultImg
                            }
                        />
                        <ConstructionIcon className={classes.icon} />
                    </>
                ) : (
                    <Link to={BDTRoutes.Project.Dashboard.Builder(project.id)}>
                        <CardMedia
                            className={isReady ? classes.media : classes.mediaGray}
                            image={
                                project.projectImageStr
                                    ? project.projectImageStr
                                    : projectCardDefaultImg
                            }
                        />
                        {!isReady && <EngineeringIcon className={classes.icon} />}
                    </Link>
                )}

                <CardContent>
                    <Typography variant="subtitle2">{project.name}</Typography>
                    <Typography color="primary" variant="subtitle2">
                        {message()}
                    </Typography>
                    <Typography variant="body2">{project.description}</Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

export default ProjectCard;
